import { useState } from 'react'
import { IconButton } from '@mui/material'
import { Delete, Settings } from '@mui/icons-material'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { useSearchParam } from 'react-use'

import services from '../../../services'

export function useData() {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedItem = useSearchParam('item')
  const {
    data: assessments,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['/exams'],
    queryFn: services.assessment.getAll,
  })

  const { data: lessons } = useQuery({
    queryKey: ['/lessons'],
    queryFn: services.lessons.getAll,
  })
  const { data: modules } = useQuery({
    queryKey: ['/modules'],
    queryFn: services.modules.getAll,
  })

  const [loading, setLoading] = useState<boolean>(false)

  const deleteItem = async (id: string) => {
    setLoading(true)
    await services.assessment.deleteById(id).finally(() => {
      refetch().finally(() => setLoading(false))
    })
  }

  const CellActions = (itemId: string) => (
    <div className="flex flex-wrap gap-1 items-center">
      <IconButton
        sx={{ color: 'white' }}
        onClick={() => {
          searchParams.set('item', itemId)
          setSearchParams(searchParams)
        }}
      >
        <Settings />
      </IconButton>

      <IconButton sx={{ color: 'white' }} onClick={() => deleteItem(itemId)}>
        <Delete />
      </IconButton>
    </div>
  )

  return {
    isLoading: isLoading || loading,
    error,
    assessments,
    CellActions,
    refetch,
    selectedItem,
    lessons,
    modules,
  }
}
